import {isLocalhost} from './shared/serverFunctions';
import Config from "./messages";

/**
 * Systems
 *
 * GET_LIST
 */
export const RESOURCES = {
    "Systems": {
        GET_LIST: function (params) {
            const server = (isLocalhost) ? localStorage.getItem('server') : Config.fuse.api.RELATIVE_API_URI;
            return {
                "type": "list",
                "method": "GET",
                "title": "Systems",
                "uri": server + "/api/v5/admin/subscriber/getAll"
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "Systems"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseSystemsResourceMap.js